import axios from 'axios';
import {backendHost} from '../../config';

export const getMailing = (params) => {
    return axios.get(`${backendHost}/api/admin/v2/mailing`, {params});
};